import React from 'react'
import InputText from '@Components/Fields/InputText'
import Dropdown from '@Components/Selectors/Dropdown'
import { TOOLTIP_TEXT } from '@Const/tooltip-text'
import { IWorkDetailsValidations } from '@App/interfaces/validations'
import { OptionModel } from '@Entities/lib'
import { WorkDetailsModel } from '@Entities/work/work-details-model'

interface WorkDetailsFieldsProps {
    workDetails: Partial<WorkDetailsModel>
    validation: IWorkDetailsValidations
    languageOptions: OptionModel[]
    originalWorkDetails: Partial<WorkDetailsModel>
    isSubmittedWork: boolean
    workTitle: string
    onChange: (value: string | number | boolean | null, id: string) => void
}

const WorkDetailsFields = ({
    workDetails,
    validation,
    languageOptions,
    originalWorkDetails,
    isSubmittedWork,
    workTitle,
    onChange,
}: WorkDetailsFieldsProps) => {
    const { title, duration, languageCode, rightsholderProprietaryId, iswc } = workDetails

    return (
        <div className="details-create-work-wizard">
            <h6>Enter Work Details</h6>
            <div className="normal">
                <span>Enter work details for </span>
                <span title={workTitle}>
                    &apos;<span>{workTitle}</span>&apos;
                </span>
                <span> below.</span>
            </div>
            <div className="inputs-field">
                <div className="title-area">
                    <InputText
                        mainColor
                        id="title"
                        label="Work Title"
                        assistiveText="Required"
                        value={title}
                        onChange={onChange}
                        errorMessage={validation.title.error}
                        required={validation.title.required}
                        disabled={isSubmittedWork}
                        isEscapeNewlines
                    />
                </div>

                <Dropdown
                    options={languageOptions}
                    id="languageCode"
                    placeholder="Language"
                    label="Language"
                    mainColor
                    onChange={onChange}
                    isNumberType
                    isSearchable
                    selectedValue={languageCode ? languageOptions.find((option) => +option.id === languageCode) : null}
                    assistiveText="Optional - This can't be changed after submission"
                    isDisabled={isSubmittedWork && originalWorkDetails.languageCode !== null}
                />

                <InputText
                    mainColor
                    id="iswc"
                    label="ISWC"
                    value={iswc}
                    onChange={onChange}
                    errorMessage={validation.iswc.error}
                    required={validation.iswc.required}
                    assistiveText="Optional - This can't be changed after submission"
                    helperTitleText={TOOLTIP_TEXT.createWork.iswc}
                    helperType="?"
                    disabled={isSubmittedWork && originalWorkDetails.iswc !== null}
                />

                <InputText
                    mainColor
                    id="duration"
                    label="Duration"
                    value={duration ? duration : ''}
                    onChange={onChange}
                    errorMessage={validation.duration.error}
                    required={validation.duration.required}
                />

                <InputText
                    mainColor
                    id="rightsholderProprietaryId"
                    label="Member Work Identifier"
                    value={rightsholderProprietaryId}
                    onChange={onChange}
                    errorMessage={validation.rightsholderProprietaryId.error}
                    required={validation.rightsholderProprietaryId.required}
                    helperTitleText={TOOLTIP_TEXT.createWork.rightsholderProprietaryId}
                    helperType="?"
                />
            </div>
        </div>
    )
}

export default WorkDetailsFields
